var map = {
	"./ageOfTheFranks.webp": 86843,
	"./bronzeAge.webp": 65850,
	"./byzantineEra.webp": 91561,
	"./classicGreece.webp": 538,
	"./earlyGothicEra.webp": 41702,
	"./earlyRome.webp": 60811,
	"./feudalAge.webp": 70325,
	"./highMiddleAges.webp": 60970,
	"./iberianEra.webp": 37273,
	"./kingdomOfSicily.webp": 11886,
	"./lateGothicEra.webp": 58929,
	"./minoanEra.webp": 64009,
	"./romanEmpire.webp": 38888,
	"./stoneAge.webp": 73015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47012;